export const vodafoneTariffHeaders = [
  {
    value: 'id',
    label: 'ID',
    sortable: true,
  },
  {
    value: 'person_id',
    label: 'Person ID',
    sortable: true,
  },
  {
    value: 'phone_number',
    label: 'Telefonní číslo',
    sortable: true,
  },
  {
    value: 'email',
    label: 'Email',
    sortable: true,
  },
  {
    value: 'first_name',
    label: 'Jméno',
    sortable: true,
  },
  {
    value: 'last_name',
    label: 'Příjmení',
    sortable: true,
  },
  {
    value: 'application_type',
    label: 'Typ žádosti',
    sortable: true,
  },
  {
    value: 'sim_type',
    label: 'Typ SIM',
    sortable: true,
  },
  {
    value: 'fakturoid_subject_id',
    label: 'Fakturoid ID',
    sortable: true,
  },
  {
    value: 'oldest_pending_period',
    label: 'Nejstarší nezaplacené období',
    sortable: false,
  },
  {
    value: 'transfer_date',
    label: 'Datum přenosu',
    sortable: true,
  },
  {
    value: 'created_at',
    label: 'Vytvořeno',
    sortable: true,
  },
  {
    value: 'note',
    label: 'Poznámka',
    sortable: true,
  },
  {
    value: 'transfer_requested',
    label: 'Zažádáno o přenos',
    sortable: true,
  },
  {
    value: 'actions',
    label: 'Akce',
    sortable: false,
  },
];

// Tab-specific column configurations
export const tabSpecificColumns = {
  "paid": [
    'id',
    'person_id',
    'phone_number',
    'email',
    'first_name',
    'last_name',
    'application_type',
    'sim_type',
    'created_at',
    'note',
    'actions',
  ],
  "requested-transfer": [
    'id',
    'phone_number',
    'email',
    'transfer_requested',
    'first_name',
    'last_name',
    'application_type',
    'sim_type',
    'note',
    'actions',
  ],
  "overdue-payments": [
    'id',
    'phone_number',
    'email',
    'fakturoid_subject_id',
    'oldest_pending_period',
    'first_name',
    'last_name',
    'note',
    'actions',
  ],
  "active": [
    'id',
    'phone_number',
    'email',
    'first_name',
    'last_name',
    'note',
    'actions',
  ],
    "cancelled": [
      'id',
      'phone_number',
      'email',
      'first_name',
      'last_name',
      'note',
      'actions',
    ],
  "deactivated": [
    'id',
    'phone_number',
    'email',
    'fakturoid_subject_id',
    'first_name',
    'last_name',
    'note',
    'actions',
  ],
  // Add other tabs as needed
  default: vodafoneTariffHeaders.map(header => header.value),
};

// Function to get headers for specific tab
export const getHeadersForTab = (tabName: string) => {
  const columnsForTab = tabSpecificColumns[tabName as keyof typeof tabSpecificColumns] || tabSpecificColumns.default;
  
  // If using default (all columns), return in original order
  if (columnsForTab === tabSpecificColumns.default) {
    return vodafoneTariffHeaders;
  }
  
  // For specific tab configurations, maintain the order specified in tabSpecificColumns
  return columnsForTab.map(columnValue => {
    const header = vodafoneTariffHeaders.find(h => h.value === columnValue);
    if (!header) {
      console.warn(`Header not found for column: ${columnValue}`);
      return null;
    }
    return header;
  }).filter(Boolean) as typeof vodafoneTariffHeaders;
};
